<template>
<span class="time-ago">
    {{timeFormatted}}
</span>
</template>

<script>
import { format, formatDistanceStrict, differenceInDays, fromUnixTime } from 'date-fns';
import {ru, en, tr, es, pt, de, fr, id, pl} from 'date-fns/locale';

const locales = {ru, en, tr, es, pt, de, fr, id, pl};

export default {
    data() {
        return {
            start: null,
            end: new Date()
        };
    },
    computed: {
        timeFormatted() {
            if (differenceInDays(this.end, this.start) < 10) {
                return formatDistanceStrict(this.start, this.end, {
                    locale: locales[this.locale],
                    addSuffix: true
                });
            } else {
                return format(this.start, 'PP', {locale: locales[this.locale]});
            }
        }
    },
    props: ['time','locale'],
    created() {
        this.start = fromUnixTime(this.time);
    }
}
</script>

<style>
    
</style>